import React from 'react';
import {useAppState, MarkupRender, SubscriptionForm, notifySuccess} from "@nutastic/nutastic-react-app";
import PageHeader from "../PageHeader";

const SubscriptionPage = () => {
    const {
        page: {
            image_1,
            title,
            content,
            field_10: subtext,
            field_1: formText,
            num_5: header_type,
        }
    } = useAppState();
    const componentClass = 'subscription-page';

    return <React.Fragment>
        <PageHeader image={image_1} title={title} subtext={subtext} type={header_type} />
        <section className={`page-section`}>
            <div className="container text-left">
                <div className="paragraph"><MarkupRender content={content} /></div>
                <div className="clear clear--xxl" />
                <div className={`${componentClass}__form`}>
                    <p>{ formText }</p>
                    <SubscriptionForm onSubmit={() => notifySuccess('Thank you for subscribing to the newsletter!')} />
                </div>
            </div>
        </section>
    </React.Fragment>
};

export default SubscriptionPage;
